import React, { useEffect, useState, useMemo, memo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, IconButton, useTheme, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { tokens } from '../../../theme';
import Header from "../../../components/Header";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import useMediaQuery from '@mui/material/useMediaQuery';
import { getAllPendingDealer } from '../../../redux/slice/Commercialmarketing.slice';
import { deleteDealer } from '../../../redux/slice/dealer.slice';
import { Image_URL } from '../../../utils/baseURL';

const MarketDataGrid = memo(({ data, columns }) => {
    if (!data || !Array.isArray(data)) {
        return <div>No Pending Market...</div>;
    }

    return (
        <DataGrid
            rows={data}
            columns={columns}
            components={{ Toolbar: GridToolbar }}
            pageSize={5}
            rowsPerPageOptions={[5, 10]}
            getRowId={(row) => row._id}
            density="compact"
            autoHeight
            sx={{
                "@media print": {
                    "& .MuiDataGrid-toolbarContainer": {
                        display: "none !important"
                    },
                    "& .MuiDataGrid-root": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-cell": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-footerContainer": {
                        color: "black !important",
                    },
                    "& .css-7ms3qr-MuiTablePagination-displayedRows": {
                        color: "black !important",
                    },
                },
            }}
        />
    );
});

const PandingMarket = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const colors = tokens(theme.palette.mode);
    const imgUrl = Image_URL;
    const [openView, setOpenView] = React.useState(false);
    const [viewData, setViewData] = useState(null);
    const downloadRef = useRef(null);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const DealerRegister = useSelector(state => state.comMarketing.pendingDealer);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deletedealer, setDeleteDealer] = useState(null);
    const [imageViewOpen, setImageViewOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const isMobile = useMediaQuery('(max-width:500px)');

    const handleClickOpenView = () => {
        setOpenView(true);
    };

    const handleCloseView = () => {
        setOpenView(false);
    };

    const handleImageView = (imagePath) => {
        setSelectedImage(`${imgUrl}/${imagePath}`);
        setImageViewOpen(true);
    };

    const handleCloseImageView = () => {
        setImageViewOpen(false);
        setSelectedImage(null);
    };

    const handleDelete = (id) => {
        setDeleteDealer(id);
        setDeleteConfirmOpen(true);
    };

    const confirmDelete = () => {
        if (deletedealer) {
            dispatch(deleteDealer(deletedealer));
            setDeleteConfirmOpen(false);
            setDeleteDealer(null);
        }
    }
    const cancelDelete = () => {
        setDeleteConfirmOpen(false);
        setDeleteDealer(null);
    }

    const navigate = useNavigate();
    const [update, setUpdate] = useState(null);
    const [open, setOpen] = useState(false);
    const handleEdit = (data) => {

        localStorage.setItem("pending_id", data._id)
        const matchingData = data.data?.find(item => item.Dealer === data._id);

        if (matchingData) {
            navigate('/admin/add-market', {
                state: {
                    id: matchingData._id,
                    dealerset: matchingData._id
                }
            });
        } else {
            navigate('/admin/add-market', {
                state: {
                    dealerset: data._id
                }
            });
        }
    };
    const handleView = (data) => {
        handleClickOpenView();
        setViewData(data)
    }

    const [openViewImage, setOpenViewImage] = React.useState(false);
    const [viewImage, setViewImage] = useState(null);

    const handleViewImage = (imageType) => {
        let imageUrl;
        if (imageType === 'adharCard') {
            imageUrl = `${imgUrl}/${viewData?.adharCard}`;
        } else if (imageType === 'lightBill') {
            imageUrl = `${imgUrl}/${viewData?.lightBill}`;
        } else if (imageType === 'veraBill') {
            imageUrl = `${imgUrl}/${viewData?.veraBill}`;
        }
        setViewImage(imageUrl);
        setOpenViewImage(true);
    };

    const handleCloseViewImage = () => {
        setOpenViewImage(false);
    };

    const handleDownload = async () => {
        if (viewImage) {
            try {
                let imageUrl;
                if (viewData && viewData._id) {
                    if (viewImage.includes("4000")) {
                        const proxyUrl = `/api/proxy-image?url=${encodeURIComponent(viewImage)}`;
                        imageUrl = proxyUrl;
                    } else {
                        imageUrl = viewImage;
                    }
                } else {
                }
                const response = await fetch(imageUrl);
                if (response.ok) {
                    const blob = await response.blob();
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = 'downloaded-image.png';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                } else {
                    console.error('Failed to download image');
                }
            } catch (error) {
                console.error('Error in download process:', error);
            }
        } else {

        }
    };

    const isInitialMount = useRef(true);

    useEffect(() => {
        dispatch(getAllPendingDealer());
    }, []);

    const columns = useMemo(() => [
        { field: 'ConsumerName', headerName: 'Name', width: 280 },
        {
            field: 'PhoneNumber', headerName: 'Contact No', width: 160,
        },
        {
            field: 'amount', headerName: 'Amount', width: 150,
        },
        {
            field: 'SystemSize', headerName: 'SystemSize', width: 140,
        },
        {
            field: 'payment_as_loan', headerName: 'Recd Payment As a loan', width: 140,
        },
        {
            field: 'type_loan', headerName: 'Type of loan', width: 140,
        },
        {
            field: 'name',
            headerName: 'Dealer Name',
            width: 200,
            valueGetter: (params) => {
                return params.row.userData?.[0]?.name || 'N/A';
            }
        },
        {
            field: 'status', headerName: 'Status', width: 120,
            filterable: true,
            valueGetter: (params) => 'Pending',
            renderCell: (params) => 'Pending',
        },
        {
            field: 'Action',
            headerName: 'Action',
            width: 130,
            renderCell: (params) => (
                <>
                    <IconButton aria-label="view" onClick={() => handleView(params.row)}>
                        <RemoveRedEyeIcon />
                    </IconButton>
                    <IconButton aria-label="edit" onClick={() => handleEdit(params.row)}>
                        <EditIcon />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleDelete(params.row._id)}>
                        <DeleteIcon />
                    </IconButton>
                </>
            )
        }
    ], []);

    const filteredDealerRegister = Array.isArray(DealerRegister) ? DealerRegister.filter(dealer => {
        const hasMatchingData = dealer?.status === "Pending";

        return hasMatchingData;
    }) : [];

    return (
        <Box m="2px" >
            <Header
                title="PENDING MARKETING"
                subtitle="Manage Your Pending Marketing Here"
            />
            <Box
                height="75vh"
                sx={useMemo(() => ({
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                        fontSize: "13px !important",
                    },
                }), [colors])}
            >
                <MarketDataGrid data={filteredDealerRegister} columns={columns} />

            </Box>

            <Dialog
                fullScreen={fullScreen}
                open={openView}
                onClose={handleCloseView}
                aria-labelledby="responsive-dialog-title"
                maxWidth={"sm"}
                fullWidth
            >
                <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: 'center', fontWeight: 'bold' }}>
                    {"Dealer Details"}
                </DialogTitle>
                <DialogContent style={{ backgroundColor: theme.palette.background.purple }}>
                    <DialogContentText>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px' }}>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong> Name : </strong> {viewData?.ConsumerName}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Contact No : </strong> {viewData?.PhoneNumber}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Amount : </strong> {viewData?.amount}</p>

                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>System Size : </strong> {viewData?.SystemSize}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>System Size : </strong> {viewData?.SystemSize}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Recd Payment As a loan : </strong> {viewData?.payment_as_loan}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Type of loan: </strong> {viewData?.type_loan || 'N/A'}</p>
                            {viewData?.MultipleDetails && viewData?.MultipleDetails.length > 0 && viewData?.MultipleDetails.map((detail, index) => (
                                <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px', display: "flex", alignItems: "center" }}>
                                    <strong>{detail?.inputField} : </strong>
                                    <div style={{ maxWidth: '100%', maxHeight: '80vh' }} >
                                        {detail?.dealerImage.endsWith('.pdf') ? (
                                            <iframe
                                                src={`${imgUrl}/${detail?.dealerImage}`}
                                                style={{ width: '50px', height: '50px', border: 'none', marginLeft: '20px' }}
                                                title="PDF Preview"
                                            />
                                        ) : (
                                            <img
                                                style={{ width: '50px', height: '50px', objectFit: 'cover', marginLeft: '20px' }}
                                                src={`${imgUrl}/${detail?.dealerImage}`}
                                                alt={detail?.inputField}
                                            />
                                        )}
                                    </div>
                                    <IconButton onClick={() => handleImageView(detail?.dealerImage)}>
                                        <RemoveRedEyeIcon />
                                    </IconButton>
                                </p>
                            ))}
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                    <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteConfirmOpen} onClose={cancelDelete}>
                <DialogContent>
                    Are you sure you want to delete this Pending Market?
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDelete} style={{ color: theme.palette.text.primary }}>No</Button>
                    <Button onClick={confirmDelete} style={{ color: theme.palette.text.primary }}>Yes</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={imageViewOpen}
                onClose={handleCloseImageView}
                maxWidth="md"
                fullWidth
            >
                <DialogContent>
                    {selectedImage ? (
                        <div style={{ textAlign: 'center' }} >
                            {selectedImage.endsWith('.pdf') ? (
                                <iframe
                                    src={selectedImage}
                                    style={{ width: '800px', height: '80vh', border: 'none', textAlign: 'center' }}
                                    title="PDF Preview"
                                />
                            ) : (
                                <img
                                    src={selectedImage}
                                    alt="Uploaded Image"
                                    style={{ width: '700px', height: 'auto', textAlign: 'center' }}
                                    ref={downloadRef}
                                />
                            )}
                        </div>
                    ) : (
                        <p>No image to display</p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseImageView} sx={{ color: theme.palette.text.primary }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

        </Box >
    );
};

export default PandingMarket;